// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tittle{
    font-family: "Montserrat", sans-serif;
    font-size: 2rem;
    font-weight: 700;
}

.stage-completed{
    background-color: black;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    min-width: 65px;
    min-height: 65px;
    align-items: center;
}

.stage-remaining{
    background-color: #d9d9d9;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    min-width: 65px;
    min-height: 65px;
    align-items: center;
}

.selected {
    background-color: #ffeacc;
    border-radius: 10px;
}

.lineHeight{
    text-align: center;
}

.no-focus-border:focus {
    outline: none !important;
    box-shadow: none !important;
  }

  .thick-border {
    border-top-width: 2.5px !important; /* Ajusta este valor a tus necesidades */
  }

  .info-tooltip{
    background-color: #d9d9d9;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: small;
    cursor: pointer;
}

/* Ajustes de tipografía y separación para móvil en la pantalla
   "Complete el KYC con su:" (textos bajo los iconos) */
@media screen and (max-width: 480px) {
  .text-phone p {
    line-height: 1.15 !important;
    margin: 2px 0 !important;
  }
}

.btn-yes-or-no {
    width: 60px; /* Cambia '100px' al ancho que prefieras */
    /* height: 50px;  Cambia '50px' a la altura que prefieras */
    display: inline-block;
}

@media screen and (min-width: 768px){
    .stage-remaining{
        width: 90px;
        height: 90px;
    }
    .stage-completed{
        width: 90px;
        height: 90px;
    }
    .lineHeight{
        line-height: 6px;
    }

}


  
.input-container {
    position: relative;
  }
  
  .borderless-input {
    width: 100%;
    padding: 10px;
    border: none;
    outline: none;
    background-color: transparent;
    font-size: 16px;
  }
  
  .w-100 {
    width: 100%;
  }
  
  .mat-select-country {
    width: 100%;
    background-color: white;
  }
  
  .thick-border {
    height: 2px;
    background-color: #ccc;
  }
  
  .input-container {
    position: relative;
    width: 100%;
  }

  /* Estilos para los botones EMPRESA/PERSONA */
  .btn-outline-dark {
    border: 1px solid #333 !important;
    background-color: white !important;
    color: #333 !important;
    padding: 10px 20px !important;
    font-weight: bold !important;
    font-family: 'Montserrat', sans-serif !important;
  }

  .btn-outline-dark:hover {
    background-color: #f8f9fa !important;
    border-color: #333 !important;
    color: #333 !important;
  }

  .btn-dark {
    background-color: #333 !important;
    border: 1px solid #333 !important;
    color: white !important;
    padding: 10px 20px !important;
    font-weight: bold !important;
    font-family: 'Montserrat', sans-serif !important;
  }

  .btn-dark:hover {
    background-color: #555 !important;
    border-color: #555 !important;
    color: white !important;
  }
  

  
  ::ng-deep .ipv_selected-item {
    border: none;
    height: 20px;
  }
  

  ::ng-deep .custom-select {
    width: 4rem;
    padding-bottom: 0rem;
    height: 2.4rem;

    mat-form-field-wrapper {
      padding-bottom: 0;
    }
  
    .mat-form-field-underline {
      display: none;
    }
  
    .mat-form-field-flex {
      border: none; 
    }

    .search-input {
      width: 100%;   
      border: 1px solid #ccc;
      border-radius: 4px;      
      padding: 4px;           
    }
  }
  


  `, "",{"version":3,"sources":["webpack://./src/app/components/modal-kyc/kyc-stages/kyc-stages.component.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;EAC7B;;EAEA;IACE,kCAAkC,EAAE,wCAAwC;EAC9E;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;uDACuD;AACvD;EACE;IACE,4BAA4B;IAC5B,wBAAwB;EAC1B;AACF;;AAEA;IACI,WAAW,EAAE,0CAA0C;IACvD,2DAA2D;IAC3D,qBAAqB;AACzB;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,gBAAgB;IACpB;;AAEJ;;;;AAIA;IACI,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA,6CAA6C;EAC7C;IACE,iCAAiC;IACjC,kCAAkC;IAClC,sBAAsB;IACtB,6BAA6B;IAC7B,4BAA4B;IAC5B,gDAAgD;EAClD;;EAEA;IACE,oCAAoC;IACpC,6BAA6B;IAC7B,sBAAsB;EACxB;;EAEA;IACE,iCAAiC;IACjC,iCAAiC;IACjC,uBAAuB;IACvB,6BAA6B;IAC7B,4BAA4B;IAC5B,gDAAgD;EAClD;;EAEA;IACE,iCAAiC;IACjC,6BAA6B;IAC7B,uBAAuB;EACzB;;;;EAIA;IACE,YAAY;IACZ,YAAY;EACd;;;EAGA;IACE,WAAW;IACX,oBAAoB;IACpB,cAAc;;IAEd;MACE,iBAAiB;IACnB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,WAAW;MACX,sBAAsB;MACtB,kBAAkB;MAClB,YAAY;IACd;EACF","sourcesContent":[".tittle{\n    font-family: \"Montserrat\", sans-serif;\n    font-size: 2rem;\n    font-weight: 700;\n}\n\n.stage-completed{\n    background-color: black;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    min-width: 65px;\n    min-height: 65px;\n    align-items: center;\n}\n\n.stage-remaining{\n    background-color: #d9d9d9;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    min-width: 65px;\n    min-height: 65px;\n    align-items: center;\n}\n\n.selected {\n    background-color: #ffeacc;\n    border-radius: 10px;\n}\n\n.lineHeight{\n    text-align: center;\n}\n\n.no-focus-border:focus {\n    outline: none !important;\n    box-shadow: none !important;\n  }\n\n  .thick-border {\n    border-top-width: 2.5px !important; /* Ajusta este valor a tus necesidades */\n  }\n\n  .info-tooltip{\n    background-color: #d9d9d9;\n    border-radius: 50%;\n    width: 20px;\n    height: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n    font-size: small;\n    cursor: pointer;\n}\n\n/* Ajustes de tipografía y separación para móvil en la pantalla\n   \"Complete el KYC con su:\" (textos bajo los iconos) */\n@media screen and (max-width: 480px) {\n  .text-phone p {\n    line-height: 1.15 !important;\n    margin: 2px 0 !important;\n  }\n}\n\n.btn-yes-or-no {\n    width: 60px; /* Cambia '100px' al ancho que prefieras */\n    /* height: 50px;  Cambia '50px' a la altura que prefieras */\n    display: inline-block;\n}\n\n@media screen and (min-width: 768px){\n    .stage-remaining{\n        width: 90px;\n        height: 90px;\n    }\n    .stage-completed{\n        width: 90px;\n        height: 90px;\n    }\n    .lineHeight{\n        line-height: 6px;\n    }\n\n}\n\n\n  \n.input-container {\n    position: relative;\n  }\n  \n  .borderless-input {\n    width: 100%;\n    padding: 10px;\n    border: none;\n    outline: none;\n    background-color: transparent;\n    font-size: 16px;\n  }\n  \n  .w-100 {\n    width: 100%;\n  }\n  \n  .mat-select-country {\n    width: 100%;\n    background-color: white;\n  }\n  \n  .thick-border {\n    height: 2px;\n    background-color: #ccc;\n  }\n  \n  .input-container {\n    position: relative;\n    width: 100%;\n  }\n\n  /* Estilos para los botones EMPRESA/PERSONA */\n  .btn-outline-dark {\n    border: 1px solid #333 !important;\n    background-color: white !important;\n    color: #333 !important;\n    padding: 10px 20px !important;\n    font-weight: bold !important;\n    font-family: 'Montserrat', sans-serif !important;\n  }\n\n  .btn-outline-dark:hover {\n    background-color: #f8f9fa !important;\n    border-color: #333 !important;\n    color: #333 !important;\n  }\n\n  .btn-dark {\n    background-color: #333 !important;\n    border: 1px solid #333 !important;\n    color: white !important;\n    padding: 10px 20px !important;\n    font-weight: bold !important;\n    font-family: 'Montserrat', sans-serif !important;\n  }\n\n  .btn-dark:hover {\n    background-color: #555 !important;\n    border-color: #555 !important;\n    color: white !important;\n  }\n  \n\n  \n  ::ng-deep .ipv_selected-item {\n    border: none;\n    height: 20px;\n  }\n  \n\n  ::ng-deep .custom-select {\n    width: 4rem;\n    padding-bottom: 0rem;\n    height: 2.4rem;\n\n    mat-form-field-wrapper {\n      padding-bottom: 0;\n    }\n  \n    .mat-form-field-underline {\n      display: none;\n    }\n  \n    .mat-form-field-flex {\n      border: none; \n    }\n\n    .search-input {\n      width: 100%;   \n      border: 1px solid #ccc;\n      border-radius: 4px;      \n      padding: 4px;           \n    }\n  }\n  \n\n\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
